( function( $ ) {
	$(document).ready(function(){
    $(".wysiwyg").fitVids();
 });
} )( jQuery );